export const ROLE_LABELS = {
  super_admin: "Platform Owner",
  tenant_admin: "Institution Admin",
  director: "Director of Research",
  registrar: "Registrar",
  supervisor: "Supervisor",
  staff: "Research Office",
  student: "Student",
  qa: "Quality Assurance",
};

export function roleOf(user) {
  return user?.platform_role || user?.tenant_role;
}

// which roles can see each route
export const ACCESS = {
  dashboard: ["super_admin", "tenant_admin", "director", "registrar", "supervisor", "staff", "student", "qa"],
  institutions: ["super_admin"],
  admissions: ["tenant_admin", "registrar", "staff"],
  concept: ["tenant_admin", "director", "staff", "supervisor", "student"],
  supervision: ["tenant_admin", "director", "staff", "supervisor", "student", "qa"],
  oversight: ["tenant_admin", "director"],
  analytics: ["tenant_admin", "director", "staff", "supervisor", "qa"],
  users: ["tenant_admin"],
  audit: ["tenant_admin", "director", "qa"],
  settings: ["tenant_admin"],
  profile: ["super_admin", "tenant_admin", "director", "registrar", "supervisor", "staff", "student", "qa"],
  notifications: ["super_admin", "tenant_admin", "director", "registrar", "supervisor", "staff", "student", "qa"],
};

export function can(user, key) {
  return ACCESS[key]?.includes(roleOf(user));
}
